export default __webpack_public_path__ + "static/media/s-squiggle-141.68857712.svg";